/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_8_Questions_2_QuestionInputs */

const en_gc_search_guides_gridcraft_excel_compatibility_sections_8_questions_2_question = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_8_Questions_2_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I replace the original after one successful test?`)
};

const zh_gc_search_guides_gridcraft_excel_compatibility_sections_8_questions_2_question = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_8_Questions_2_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一次测试成功后就能替换原文件吗？`)
};

/**
* | output |
* | --- |
* | "Can I replace the original after one successful test?" |
*
* @param {Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_8_Questions_2_QuestionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_excel_compatibility_sections_8_questions_2_question = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_8_Questions_2_QuestionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_8_Questions_2_QuestionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_excel_compatibility_sections_8_questions_2_question(inputs)
	return zh_gc_search_guides_gridcraft_excel_compatibility_sections_8_questions_2_question(inputs)
});
export { gc_search_guides_gridcraft_excel_compatibility_sections_8_questions_2_question as "gc.search_guides.gridcraft_excel_compatibility.sections.8.questions.2.question" }